import styled, { css } from 'styled-components'
import { InputStyleProps, InputMainWrapperProps, InputWrapperProps, IconWrapperProps } from './types'
import { FontStyle } from '../../Core/Typography/Font/Font.styles'

export const InputMainWrapper = styled('div') <InputMainWrapperProps>`
  width: ${props => props.width ? props.width : (props.fixWidth ? '240px' : 'auto')};
  min-width: 100px;
  min-height: ${props => props.minHeight || '84px'};
  margin-bottom: ${props => props.marginBottom || '8px'};
  padding-left: ${props => props.paddingLeft || '0'};
  box-sizing: border-box;
  user-select: none;
  ${props =>
    props.gridArea &&
    css`
      grid-area: ${props.gridArea};
    `}
  ${props =>
    props.gridColumn &&
    css`
      grid-column: ${props.gridColumn};
    `}
  ${props =>
    props.addSeparatorLine &&
    css`
      margin-bottom: 30px;
      padding-bottom: 12px;
      border-bottom: 1px solid ${props.theme.colors.shades.neutral[1]};
    `}
  ${props =>
    props.flexProperties &&
    css`
      display: flex;
      flex-direction: ${props.flexProperties?.flexDirection || 'column'};
      justify-content: ${props.flexProperties?.justifyContent || 'center'};
    `
  }
`

export const InputWrapper = styled.div<InputWrapperProps>`
  position: relative;

  ${props =>
    props.labelSpacer &&
    css`
      padding-top: 28px;
    `}
  ${props =>
    props.width &&
    css`
      width: ${props.width};
    `}
`

export const InputStyle = styled('input') <InputStyleProps>`
  appearance: none;
  margin: ${props => props.inputStyleMargin || '4px 0 8px 0'};
  padding: ${props => props.inputStylePadding || '8px 10px'};
  background-color: ${props => props.theme.colors.main.background};
  border: 1px solid ${props => props.theme.colors.shades.neutral[1]};
  border-radius: 4px;
  width: calc(100% - 22px);
  max-width: 100vw;
  height: 14px;
  font-size: 12px;
  resize: ${props => props.resize || 'vertical'};
  cursor: ${props => props.disabled ? 'not-allowed' : (props.isDatePicker ? 'pointer' : 'text')};
  font-family: ${props => props.theme.font.family[0]};
  ::placeholder {
    color: ${props => props.theme.colors.shades.neutral[2]};
    font-size: 14px;
  }
  &::-webkit-input-placeholder {
    color: ${props => props.theme.colors.shades.neutral[2]};
    font-size: 14px;
  }
  &:-ms-input-placeholder {
    color: ${props => props.theme.colors.shades.neutral[2]};
    font-size: 14px;
  }
  &::-ms-input-placeholder {
    color: ${props => props.theme.colors.shades.neutral[2]};
    font-size: 14px;
  }

  &:hover {
    border: 1px solid ${props => props.theme.colors.shades.neutral[2]};
  }

  &:focus {
    border: 1px solid ${props => props.theme.colors.main.ultraViolet};
  }

  &:focus-visible {
    outline: none;
  }

  &:disabled {
    background-color: ${props => props.theme.colors.shades.neutral[0]};
  }

  &[type="number"]::-webkit-inner-spin-button,
  &[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  ${props =>
    props.error &&
    css`
      border: 1px solid ${props => props.theme.colors.main.error};
    `}

  ${props =>
    props.isTextarea &&
    css`
      min-height: 14px;
      height: ${props.textAreaHeight || 'auto'};
      pointer-events: ${props.textAreaPointerEvents || 'auto'};
    `}

  ${props =>
    props.blocked &&
    css`
      font-weight: bold;
      background-color: ${props => props.theme.colors.shades.neutral[1]};
      user-select: none;
    `}

    ${props =>
    props.inputStyleBoxSizing && css`
        box-sizing: ${props.inputStyleBoxSizing} ;
      `}
`

export const IconWrapper = styled.div<IconWrapperProps>`
  position: absolute;
  display: flex;
  right: 8px;
  top: calc(50% - 16px);
  cursor: pointer;

  ${props =>
    props.labelSpacer &&
    css`
      top: calc(50% - 16px + 12px);
    `}
`

export const ErrorLabel = styled(FontStyle).attrs(props => {
  // @ts-ignore
  const hasEllipsis = !props.errorLabelEllipsis ? true : props.errorLabelEllipsis === 'true'
  return ({
    as: 'h6',
    tag: 'h6',
    ellipsis: hasEllipsis,
    bold: true,
  })
}) <{ errorLabelEllipsis?: string }>`
  color: ${props => props.theme.colors.main.error};
`
